export const allQuestions = {
    "marvel": {
      score: 0,
      questions: [
        {
          questionNo: 1,
          question: "THE INCREDIBLE HULK : What does Tony tell Thaddeus Ross at the end of the film?",
          points: 5,
          options: [
            { option: "a) That he wants to study The Hulk", isRight: false, bgColor: "" },
            { option: "b) That they are putting a team together.", isRight: true, bgColor: "" },
            { option: "c) That Thaddeus owes him money.", isRight: false, bgColor: "" }
          ]
          
        },
        {
          questionNo: 2,
          question: "THOR: What does Thor want 'another' of when he's in the dinner?",
          points: 5,
          options: [
            { option: "a) A slice of pie.", isRight: false },
            { option: "b) A piece of toast", isRight: false },
            { option: "A cup of coffee", isRight: true }
          ]
        },
        {
            questionNo: 3,
            question: "THE AVENGERS: Natasha remarks to Clint that the Battle of New York is a lot like what?",
            points: 5,
            options: [
              { option: "a) a) Their time in Budapest", isRight: true },
              { option: "b) a) Their time in Sokovia", isRight: false },
              { option: "a) Their time in Prague", isRight: false }
            ]
        },
        {
            questionNo: 4,
            question: "IRON MAN 3: What is the name of the little boy Tony befriends while stranded?",
            points: 5,
            options: [
              { option: "a) Harley", isRight: true },
              { option: "b) Peter", isRight: false },
              { option: "c) Henry", isRight: false }
            ]
        },
        {
            questionNo: 5,
            question: "THOR: THE DARK WORLD: Where do Sif and Volstagg hide the Reality Stone at the end of the movie?",
            points: 5,
            options: [
              { option: "a) On Vormir", isRight: false },
              { option: "b) They give it to the Collector", isRight: true },
              { option: "c) In a vault on Asgard", isRight: false }
            ]
        },
        {
          questionNo: 6,
          question: "CAPTAIN AMERICA: THE WINTER SOLDIER: What does the Winter Solider say after Steve recognizes him for the first time?",
          points: 5,
          options: [
            { option: "a) who the hell is bucky?", isRight: true },
            { option: "b) He is gone", isRight: false },
            { option: "c) Do i know you?", isRight: false }
          ]
        },
        {
          questionNo: 7,
          question: "CAPTAIN AMERICA: CIVIL WAR: Who ISN'T on Iron Man's team?",
          points: 5,
          options: [
            { option: "a) Vision", isRight: false },
            { option: "b) Black Widow", isRight: false },
            { option: "c) Hawkeye", isRight: true }
          ]
        },
        {
          questionNo: 8,
          question: "AVENGERS: AGE OF ULTRON: What word does Tony utter that makes Steve say, Language?",
          points: 5,
          options: [
            { option: "a) crap", isRight: false },
            { option: "b) shit", isRight: true },
            { option: "c) idiot", isRight: false }
          ]
        },
        {
          questionNo: 9,
          question: "THOR: RAGNAROK What is Valkyrie's scrapper number?",
          points: 5,
          options: [
            { option: "a) 3", isRight: false },
            { option: "b) 162", isRight: true },
            { option: "c) 142", isRight: false }
          ]
        },
        {
        questionNo: 10,
        question: "BLACK PANTHER: What do Killmonger and Klaue steal from the Museum of Great Britain?",
        points: 5,
        options: [
          { option: "a) Just vibranium", isRight: false },
          { option: "b) vibranium and a mask", isRight: true },
          { option: "c) A map of wakanda", isRight: false }
        ]
        },
      ]
    },
    "gaming": {
      score: 0,
      questions: [
        {
          questionNo: 1,
          question: "Which planet in the solar system would be the size of the Minecraft world, if it were real? ",
          points: 5,
          options: [
            { option: "Venus", isRight: false },
            { option: "Neptune", isRight: true },
            { option: "Earth", isRight: false }
          ]
        },
        {
          questionNo: 2,
          question: "What is the best-selling game console of all time?",
          points: 5,
          options: [
            { option: "ps5", isRight: false },
            { option: "ps2", isRight: true },
            { option: "ps3", isRight: false }
          ]
        },
        {
          questionNo: 3,
            question: "What is the most-played video game of all time?",
            points: 5,
            options: [
              { option: "Fortnite", isRight: true },
              { option: "Pubg", isRight: false },
              { option: "Clash of Clans", isRight: false }
            ]
        },
        {
          questionNo: 4,
            question: "Pacman was designed to resemble which food?",
            points: 5,
            options: [
              { option: "Burger", isRight: false },
              { option: "Sandwich", isRight: false },
              { option: "Pizza", isRight: true }
            ]
        },
        {
          questionNo: 5,
            question: "What was the name of the first video game ever created?",
            points: 5,
            options: [
              { option: "Vice city", isRight: false },
              { option: "Pacman", isRight: false },
              { option: "Pong", isRight: true }
            ]
        },
        {
          questionNo: 6,
            question: "Who released the first flight simulator game?",
            points: 5,
            options: [
              { option: "Microsoft", isRight: true },
              { option: "Google", isRight: false },
              { option: "Facebook", isRight: false }
            ]
        },
        {
          questionNo: 7,
            question: "What is the best selling videogame of all time?",
            points: 5,
            options: [
              { option: "Pong", isRight: false },
              { option: "Fortnite", isRight: false },
              { option: "Minecraft", isRight: true }
            ]
        },
        {
          questionNo: 8,
            question: "What year was Nintendo founded?",
            points: 5,
            options: [
              { option: "1889", isRight: true },
              { option: "1991", isRight: false },
              { option: "2001", isRight: false }
            ]
        },
        {
          questionNo: 9,
            question: "What is the most expensive video game made to date?",
            points: 5,
            options: [
              { option: "Fortnite", isRight: false },
              { option: "Grand Theft Auto V", isRight: true },
              { option: "Minecraft", isRight: false }
            ]
        },
        {
          questionNo: 10,
            question: "What year was the first virtual reality headset created?",
            points: 5,
            options: [
              { option: "1999", isRight: false },
              { option: "1996", isRight: false },
              { option: "1995", isRight: true }
            ]
        },
      ]
    }
  };